module.exports = __webpack_public_path__ + "img/no_mouth.6dc3ea03.png";